import React, { useCallback, useRef } from 'react'
import type { PropsWithChildren } from 'react'
import { TtIcon, TtDropdown } from '@23/react'
import { intl } from 'lang/intl'

import PanelParticipantList, {
  type PanelParticipantListOption,
} from './PanelParticipantList'

import './PanelParticipantListPopover.scss'

export interface PanelParticipantListPopoverProps {
  options: Array<PanelParticipantListOption>
  onConfirmClick?: (selectedValues: number[]) => void
}

const PanelParticipantListPopover = ({
  options,
  onConfirmClick = () => {},
}: PropsWithChildren<PanelParticipantListPopoverProps>) => {
  const dropdownRef = useRef<HTMLTtDropdownElement>(null)

  const handleConfirmClick = useCallback(
    (selectedValues: number[]) => {
      dropdownRef.current?.hide()
      onConfirmClick(selectedValues)
    },
    [onConfirmClick]
  )

  const handleCancelClick = useCallback(() => {
    dropdownRef.current?.hide()
  }, [])

  const ariaLabel = intl.formatMessage({
    defaultMessage: 'Select panel speakers',
  })

  return (
    <TtDropdown
      ref={dropdownRef}
      className="panel-participant-list-popover"
      placement="top-end"
      distance={76}
      skidding={10}
      hoist
    >
      <button
        slot="trigger"
        className="panel-selector-button"
        type="button"
        aria-label={ariaLabel}
      >
        <TtIcon name="cog" library="23" />
      </button>
      <PanelParticipantList
        options={options}
        onSubmit={handleConfirmClick}
        onCancelClick={handleCancelClick}
      />
    </TtDropdown>
  )
}

export { PanelParticipantListPopover }
